import { useJourneyBuilder } from '@opap/jbca-postmonger-react';
import type { ITokens } from '@opap/jbca-postmonger-react/lib/interfaces/tokens';
import to from 'await-to-js';
import { useEffect, useState } from 'react';
import { useSessionStorage } from './useSessionStorage';

export function useJbTokens() {
  const { getTokens } = useJourneyBuilder();
  const [tokens, setTokens] = useState<ITokens>({} as ITokens);
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { setValue: setFuel2token } = useSessionStorage('fuel2token', '');

  useEffect(() => {
    const fetchTokens = async () => {
      const [err, tokensResp] = await to(getTokens());

      if ((err || !tokensResp) && !ignore) {
        const genericError = new Error('Error fetching tokens');
        setError(genericError);
        setIsPending(false);
        console.error('Error fetching tokens:', err);
      }

      if (tokensResp && !ignore) {
        setTokens(tokensResp);
        setIsPending(false);
        setFuel2token(tokensResp.fuel2token ?? '');
      }
    };

    let ignore = false;
    fetchTokens();
    return () => {
      ignore = true;
    };
  }, [getTokens, setFuel2token]);

  return { tokens, isPending, error };
}
